import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Box, Container, Typography } from "@mui/material"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../Home/temp-data/Images"
import { useLocation } from "react-router-dom"

const Specialist = lazy(() => import("./Specialist"))
const Resources = lazy(() => import("./Resources"))
const Cta = lazy(() => import("./CTA"))


function Results() {
  const { state } = useLocation()

  return (
    <Fragment>
      <Box
        component="section"
        sx={{
          bgcolor: "dark.main",
          backgroundSize: "cover",
          backgroundImage: `url("${Images?.forumImg5}")`,
          backgroundPosition: { xs: "top left", md: "center" },
        }}
      >
        <Box
          sx={{
            bgcolor: "#00000085",
            py: { xs: 12, lg: 15 },
          }}
        >
          <Container maxWidth={false} fixed>
            <Box
              sx={{
                gap: 2.5,
                height: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                component="h2"
                sx={{
                  color: "white",
                  fontWeight: "700",
                  textShadow: "4px 4px 4px #00000073",
                  textAlign: { xs: "center", md: "start" },
                  fontSize: { xs: "25px", md: "32px", lg: "45px", xxl: "54px" },
                }}
              >Here's Your Personalized Wellness Match
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>

      <Box component="section" sx={{ py: { xs: 5, lg: 10 } }}>
        <Container maxWidth={false} fixed>
          <Typography
            mx="auto"
            maxWidth={1000}
            color="other.color1"
            variant="displayMedium"
          >Based on your responses, we recommend the following support to help you feel more balanced and empowered:
          </Typography>

          {/* {(state === "both" || state === "specialists") && */}
            <Suspense fallback={<SectionSkeleton />}>
              <Specialist />
            </Suspense>
          {/* } */}

          {(state === "both" || state === "articlesOrCourses") &&
            <Suspense fallback={<SectionSkeleton />}>
              <Resources />
            </Suspense>
          }
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <Cta />
      </Suspense>
    </Fragment >
  )
}

export default Results